import { Component, OnInit } from '@angular/core';
import * as steem from "steem";



@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})



export class SearchComponent implements OnInit {

  constructor() { }

  static nrows = 10;

  teststring = '1111111';

  postList: Array<any> = new Array();

  tagList: Map<String, Array<any>> = new Map();

  keys: Array<String> = new Array();

  loading :Array<String> = new Array();

  ngOnInit() {

   
    
  }

  searchID(searchWord: String) {
    // console.log('serchi!!!!');

    this.postList = new Array();
    this.tagList = new Map();
    this.keys = new Array();

    this.loading.push("Loading....")
    
    SearchComponent.getNextPosts(searchWord, null, this.postList, 10, this.tagList, this.keys, this.loading);

    // console.log('---------------------');
    // for(var indexI = 0 ; indexI < list.length; ++indexI) {
    //   console.log(list[indexI]);
    //   console.log(list[indexI].author + " --- " + list[indexI].root_title);
    // }
  }


  static getNextPosts(author: String, startPermlink:any, list: Array<any>, size: number, tagList: Map<String, Array<any>>, keys: Array<String>, ll :Array<String>) {

      // console.log(startPermlink + " -- " +date );
      steem.api.getDiscussionsByAuthorBeforeDateAsync(author, startPermlink, new Date().toISOString().split('.')[0], size, function (err, result) {
        // console.log(result);
        var post = null;
        var lastPermlink: any;
        for(var indexI = 0 ; indexI < result.length; ++indexI) {
            post = result[indexI];
            lastPermlink = post.permlink;

            if(indexI + 1 < result.length) {
              // console.log(post.author + " --- " + post.root_title);
              list.push(post);
            }
  
        }
        
        if(result.length >= size) {
          // console.log(lastPermlink);
          SearchComponent.getNextPosts(author, lastPermlink, list, size, tagList, keys, ll);
        } else {
          for(var indexI = 0 ; indexI < list.length; ++indexI) {
            // console.log(list[indexI]);
            // console.log(list[indexI].author + " --- " + list[indexI].root_title);
          }
          SearchComponent.sortTag(list, tagList, keys, ll);
        }
      });
      
  }

  static sortTag(list: Array<any>, tagList: Map<String, Array<any>>, keys: Array<String>, ll :Array<String>) {

    var post: any = null;

    tagList['all_all'] = new Array();
    keys.push('all_all');


    for(var indexI = 0 ; indexI < list.length; ++indexI) {
      post = list[indexI];
      
      tagList['all_all'].push(post);

      var tags = JSON.parse(post.json_metadata).tags;

      for(var indexJ = 0; indexJ < tags.length; ++indexJ) {
        
        if(tagList[tags[indexJ]] === undefined) {
          tagList[tags[indexJ]] = new Array();
          keys.push(tags[indexJ]);
        }
        tagList[tags[indexJ]].push(post);

      }

    }

    ll[0] = "";

  }

  getPostsAuthor() {
    //   start_author: lastAuthorYouLoaded,
    // start_permlink: lastPermlinkYouLoaded

    var query: any = {
      tag: '',
      start_author: 'asinayo',
      start_permlink: '5rtpas-2-2',
      limit: SearchComponent.nrows + 1
    }


    steem.api.getDiscussionsByCreated(query, function (err, result) {
      // console.log(err, result);
      console.log(SearchComponent.nrows);
      var last_author = result[SearchComponent.nrows].author;
      var last_permlink = result[SearchComponent.nrows].permlink;
      for (var i = 0; i < SearchComponent.nrows; i++) {
        var article = result[i].author + "---" + result[i].title;

        console.log(article);
        // var contents = $('#contents').html();
        // $('#contents').html(contents + article);
      }
      // last_body = $('#contents').html();
      // $('#contents
    });
  }

  getPostByAuthorTest() {
    var author = 'asinayo';
    var startPermlink = "5rtpas-2-2";
    var date = "2018-02-20T11:21:54";
    var size = 10;

    var list: Array<any> = new Array();

    steem.api.getDiscussionsByAuthorBeforeDate(author, startPermlink, date, size, function (err, result) {

      if (err != undefined) {
        console.log(err);
        return;
      }

      console.log(result);
      var post = null;
      var lastDate :String;
      var lastPermlink: String;
      for(var indexI = 0 ; indexI < result.length; ++indexI) {
          post = result[indexI];
          // console.log(post.author + " --- " + post.root_title);
          lastDate = post.created;
          lastPermlink = post.permlink;
          list.push(post);
      }

      for(var indexI = 0 ; indexI < list.length; ++indexI) {
        console.log(list[indexI]);
        console.log(list[indexI].author + " --- " + list[indexI].root_title);
      }
            
    });

    

    // var resultData = steem.api.getDiscussionsByAuthorBeforeDateAsync(author, null, date, size);
    // resultData.then(result => {
    //   var post = null;
    //   var lastDate :String;
    //   var lastPermlink: String;
    //   for(var indexI = 0 ; indexI < result.length; ++indexI) {
    //       post = result[indexI];
    //       // console.log(post.author + " --- " + post.root_title);
    //       lastDate = post.created;
    //       lastPermlink = post.permlink;
    //       list.push(post);
    //   }
    // });

    // for(var indexI = 0 ; indexI < list.length; ++indexI) {
    //   console.log(list[indexI]);
    //   console.log(list[indexI].author + " --- " + list[indexI].root_title);
      
    // }
    

  }

  getPostsByAuthor() {
    var accounts = ["asinayo"];

    console.log( new Date().toISOString().split('.')[0]);

    var resultList: Array<any> = new Array();
      // 5rtpas-2-2
    // 2018-02-20T11:21:54
    // SearchComponent.getNextPosts('asinayo', null, new Date().toISOString().split('.')[0], resultList, 10);
    // SearchComponent.getNextPosts('asinayo', '5rtpas-2-2', '2018-02-20T11:21:54', resultList, 10);


    resultList.forEach(element => {
      console.log(element.author + " --- " + element.root_title);
    });
  }

  // static getNextPosts(author: String, startPermlink:String,  date :any, list: Array<any>, size: number) {

  //   console.log(startPermlink + " -- " +date );
  //   steem.api.getDiscussionsByAuthorBeforeDate(author, startPermlink, date, size, function (err, result) {
  //     console.log(result);
  //     var post = null;
  //     var lastDate :Date;
  //     var lastPermlink: String;
  //     for(var indexI = 0 ; indexI < result.length; ++indexI) {
  //         post = result[indexI];
  //         // console.log(post.author + " --- " + post.root_title);
  //         lastDate = post.created;
  //         lastPermlink = post.permlink;
  //         list.push(post);
  //     }
      
  //     if(result.length >= size) {
  //       console.log(lastPermlink);
  //       // SearchComponent.getNextPosts(author, lastPermlink, lastDate, list, size);
  //     }
  //   });

// 
    // const resultP = steem.api.getDiscussionsByAuthorBeforeDateAsync(author, startPermlink, date, size);
    // resultP.then(result => {
    //   var post = null;
    //   var lastDate :Date;
    //   var lastPermlink: String;
    //   for(var indexI = 0 ; indexI < result.length; ++indexI) {
    //       post = result[indexI];
    //       // console.log(post.author + " --- " + post.root_title);
    //       lastDate = post.created;
    //       lastPermlink = post.permlink;
    //       list.push(post);
    //   }
      
    //   if(result.length >= size) {
    //     // console.log(lastDate);
    //     // console.log(lastPermlink);
    //     // SearchComponent.getNextPosts(author, lastPermlink, lastDate, list, size);
    //   }
    // });
  // }

  getPosts() {

    var query: any = {
      tag: '',
      auther: 'asinayo',
      limit: SearchComponent.nrows + 1
    }

    steem.api.getDiscussionsByCreated(query, function (err, result) {
      // console.log(err, result);
      console.log(SearchComponent.nrows);
      var last_author = result[SearchComponent.nrows].author;
      var last_permlink = result[SearchComponent.nrows].permlink;
      for (var i = 0; i < SearchComponent.nrows; i++) {
        var article = result[i].author + "---" + result[i].title;

        console.log(article);
        // var contents = $('#contents').html();
        // $('#contents').html(contents + article);
      }
      // last_body = $('#contents').html();
      // $('#contents
    });

  }



  getAuthor() {
    
    steem.api.setOptions({ url: 'https://api.steemit.com' });

    steem.api.getAccounts(['asinayo'], function(err, response){

      if ( err != undefined) {
        console.log(err);
      } else {
        console.log(response[0]);
      }

      
    });
  }

  getContent() {

    const resultP = steem.api.getContentAsync('asinayo', '2-4');
resultP.then(result => console.log(result));

  }

}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts